import axios from 'axios'

const actions = {
  fetchSmallProducts({ commit, getters }, trial = '') {
    if (! getters.alreadyFetchedSmallProducts) {
      return axios.get(`/api/small_products?trial=${trial}`).then(({data}) => {
        data.forEach(product => commit('addSmallProduct', product))
      })
    }
  },
  fetchMiddleProducts({ commit, getters }, trial = '') {
    if (! getters.alreadyFetchedMiddleProducts) {
      return axios.get(`/api/middle_products?trial=${trial}`).then(({data}) => {
        data.forEach(product => commit('addMiddleProduct', product))
      })
    }
  },
  fetchLargeProducts({ commit, getters }, trial = '') {
    if (! getters.alreadyFetchedLargeProducts) {
      return axios.get(`/api/large_products?trial=${trial}`).then(({data}) => {
        data.forEach(product => commit('addLargeProduct', product))
      })
    }
  },
  fetchSmallProductsRollOut({ commit, getters }, rollOut = '') {
    if (! getters.alreadyFetchedSmallProducts) {
      return axios.get(`/api/small_products?roll_out=${rollOut}`).then(({data}) => {
        data.forEach(product => commit('addSmallProduct', product))
      })
    }
  },
  fetchMiddleProductsRollOut({ commit, getters }, rollOut = '') {
    if (! getters.alreadyFetchedMiddleProducts) {
      return axios.get(`/api/middle_products?roll_out=${rollOut}`).then(({data}) => {
        data.forEach(product => commit('addMiddleProduct', product))
      })
    }
  },
  fetchLargeProductsRollOut({ commit, getters }, rollOut = '') {
    if (! getters.alreadyFetchedLargeProducts) {
      return axios.get(`/api/large_products?roll_out=${rollOut}`).then(({data}) => {
        data.forEach(product => commit('addLargeProduct', product))
      })
    }
  },
  storeDocumentsFolder({ commit }, {url, data}) {
    axios.post(url, data).then(({data}) => commit('addGeneralDocumentsFolder', data))
  },
  deleteDocumentsFolder({ commit }, {url, folder}) {
    axios.delete(`${url}/${folder.id}`).then(({data}) => commit('removeGeneralDocumentsFolder', data))
  },
  storeDocumentInFolder({ commit, state }, folder) {
    return axios.put(`/documents/${state.dragDoc.id}`, {'document_folder_id': folder.id}).then(({data}) => {
      commit('addDragedDocumentInFolder', folder)
      commit('removeGeneralDocument', state.dragDoc.id)
    })
  },
  removeDocumentFromFolder({ commit, state }, doc) {
    return axios.put(`/documents/${doc.id}`, {'document_folder_id': null})
  },
}

export default actions;



// WEBPACK FOOTER //
// ./resources/js/store/actions.js